import { CRYPTO_WALLET_STATUS, type CryptoWalletStatus } from '@modules/wallets'
import type { ToastType } from '@shared/types/toast'

// Toast copy for the eligibility blocker's "Refresh status" CTA — one row per
// backend wallet status (investor-service CryptoWalletStatus).
export const WALLET_STATUS_TOAST = {
  [CRYPTO_WALLET_STATUS.PENDING_VALIDATION]:
    'Your wallet is still being set up. Check again in a few minutes.',
  [CRYPTO_WALLET_STATUS.ACTIVE]: 'Your wallet is active. You can invest now.',
  [CRYPTO_WALLET_STATUS.VALIDATION_FAILED]:
    "We couldn't set up your wallet. Please contact support.",
  [CRYPTO_WALLET_STATUS.DEACTIVATED]: 'Your wallet has been deactivated. Please contact support.',
  notFound: "Your wallet hasn't been created yet. Check again in a few minutes.",
  failed: "We couldn't check your wallet status. Please try again.",
} as const

export const WALLET_STATUS_TOAST_TYPE: Record<CryptoWalletStatus, ToastType> = {
  [CRYPTO_WALLET_STATUS.PENDING_VALIDATION]: 'info',
  [CRYPTO_WALLET_STATUS.ACTIVE]: 'success',
  [CRYPTO_WALLET_STATUS.VALIDATION_FAILED]: 'error',
  [CRYPTO_WALLET_STATUS.DEACTIVATED]: 'warning',
}
